module.exports = __webpack_public_path__ + "static/main-700-ffa5f5ba78e46451e6ed363e6d43a7a0.png";